import { DeleteData } from 'domain/entity/deleteData';
import { Result } from 'domain/types';
import DeleteStoredAnalysisClient from 'use-case/storedAnalysis/delete/deleteStoredAnalysisClient';
import DeleteStoredAnalysisCriteria from 'use-case/storedAnalysis/delete/deleteStoredAnalysisCriteria';

export type DeleteStoredAnalysisResult = Result<DeleteData>;
export type DeleteStoredAnalysis = (criteria: DeleteStoredAnalysisCriteria) => Promise<DeleteStoredAnalysisResult>;

export default (deleteStoredAnalysisClient: DeleteStoredAnalysisClient): DeleteStoredAnalysis => (
    criteria: DeleteStoredAnalysisCriteria
): Promise<DeleteStoredAnalysisResult> => deleteStoredAnalysisClient(criteria);
